/** Comment moderation, flags/tags, commenter profiles (ALP-65/72). Owned by the moderation track. */
export const moderation = {
  title: "Moderation",
  flags: {
    spam: "Spam",
    important: "Important",
    follow_up: "Follow up",
    lead: "Lead",
    complaint: "Complaint",
    vip: "VIP",
  },
  flagMenu: {
    label: "Tags",
    trigger: "Tag",
    builtIn: "Built-in tags",
    custom: "Your tags",
    search: "Find or create a tag…",
    create: "Create tag “{{label}}”",
    created: "Tag “{{label}}” created",
    noCustom: "No custom tags yet",
    manage: "Manage tags",
    failed: "Couldn't update tags",
    add: "Add tag {{flag}}",
    remove: "Remove tag {{flag}}",
  },
  badges: {
    deleted: "Deleted on Instagram",
    deletedTip: "Deleted {{when}} {{by}}. Malfak learned it from {{source}}. The text is kept.",
    deletedBy: {
      author: "by the author",
      account: "by your account",
      platform: "by Instagram",
      unknown: "(who deleted it is unknown)",
    },
    source: {
      webhook: "a live update",
      reconcile: "the background check",
      malfak: "your action in Malfak",
    },
    recovered: "Recovered",
    recoveredTip: "Found by the background check after a missed live update. Rules ran on it as usual.",
    pinned: "Pinned",
    archived: "Archived",
    unsent: "Unsent",
    unsentTip: "The person unsent this message. Malfak kept the text.",
    edited: "Edited",
  },
  versions: {
    title: "Message history",
    original: "Original",
    edit: "Edit {{n}}",
    unsend: "Unsent",
    show: "Show history",
  },
  marks: {
    harmful: "Harmful",
    troll: "Known troll",
    vip: "VIP",
    label: "Mark",
    markAs: "Mark commenter",
    clear: "Remove mark",
    marked: "Marked as {{mark}}",
    cleared: "Mark removed",
    none: "Not marked",
  },
  filters: {
    flag: "Tag",
    anyFlag: "Any",
    deleted: "Deleted on Instagram",
    archived: "Archived",
    hide: "Hide",
    show: "Show",
    only: "Only",
  },
  actions: {
    archive: "Archive",
    unarchive: "Unarchive",
    pin: "Pin",
    unpin: "Unpin",
    archived: "Comment archived",
    unarchived: "Comment unarchived",
    pinned: "Comment pinned",
    unpinned: "Comment unpinned",
    failed: "That didn't work",
    flagged: "Tags updated",
    bulkFlag: "Tag selected",
    bulkUnflag: "Remove tag from selected",
    bulkArchive: "Archive selected",
    bulkUnarchive: "Unarchive selected",
    archiving_one: "Archiving {{count}} comment",
    archiving_other: "Archiving {{count}} comments",
    archivedMany_one: "{{count}} comment archived",
    archivedMany_other: "{{count}} comments archived",
  },
  post: {
    title: "Comments",
    reload: "Reload comments",
    reloadHint: "Fetches every comment of this post from Instagram, recovers missed ones and marks deleted ones.",
    reloadStarted: "Reloading comments",
    search: "Search comments…",
    smart: "Smart search",
    smartHint: "Finds by meaning: “delivery problems” finds late-order complaints.",
    filters: "Filters",
    clear: "Clear",
    sortLabel: "Sort",
    sort: {
      newest: "Newest",
      oldest: "Oldest",
      replies: "Most replies",
      toxicity: "Most toxic",
    },
    any: "Any",
    status: "Status",
    statusOpts: {
      visible: "Visible",
      hidden: "Hidden",
      deleted: "Deleted",
    },
    sentiment: "Sentiment",
    intent: "Intent",
    rule: "Rule that acted",
    ruleAction: "Action taken",
    replied: "Reply",
    repliedYes: "Replied",
    repliedNo: "Unreplied",
    pinnedOnly: "Pinned only",
    pinnedSection: "Pinned",
    empty: "No comments yet",
    emptyHint: "New comments arrive live. Reload to fetch everything from Instagram.",
    emptyFiltered: "No comments match",
    emptyFilteredHint: "Try fewer filters or turn off smart search.",
    count_one: "{{count}} comment",
    count_other: "{{count}} comments",
    select: "Select comment by @{{name}}",
    selectAll: "Select all",
    selected_one: "{{count}} selected",
    selected_other: "{{count}} selected",
    deselect: "Clear selection",
    open: "Open comment by @{{name}}",
    replies_one: "{{count}} reply",
    replies_other: "{{count}} replies",
    hideReplies: "Hide replies",
    hide: "Hide",
    unhide: "Unhide",
    delete: "Delete",
    deleteTitle_one: "Delete {{count}} comment on Instagram?",
    deleteTitle_other: "Delete {{count}} comments on Instagram?",
    deleteHint: "They are removed from Instagram. Malfak keeps the text, marked as deleted.",
    markDone: "Done",
    flag: "Tag",
    archive: "Archive",
    loadMore: "Load more",
    bulkRunning_one: "{{action}}: {{count}} comment",
    bulkRunning_other: "{{action}}: {{count}} comments",
    bulkDone: "{{action}} finished",
  },
  panel: {
    title: "Comment",
    thread: "Thread",
    noReplies: "No replies yet",
    runs: "Automation on this comment",
    noRuns: "No rule acted on this comment.",
    runResult: {
      executed: "Done",
      pending_approval: "Waiting for approval",
      skipped: "Skipped",
      failed: "Failed",
      suggested: "Suggested",
    },
    replyPublic: "Public reply",
    replyPrivate: "Private reply",
    privateUntil: "Private reply possible until {{date}}",
    privateUsed: "A private reply was already sent (Instagram allows one per comment).",
    privateExpired: "Private replies are only possible within 7 days of the comment.",
    privateUnavailable: "Private replies aren't available for this comment.",
    placeholder: "Write a reply…",
    send: "Send",
    sent: "Reply queued",
    sentPrivate: "Private reply queued",
    hide: "Hide",
    unhide: "Unhide",
    hidden: "Comment hidden",
    unhidden: "Comment visible again",
    delete: "Delete",
    deleteConfirm: "Delete this comment on Instagram?",
    deleteHint: "It's removed from Instagram. Malfak keeps the text, marked as deleted.",
    deleted: "Comment deleted",
    onPost: "On this post",
    viewOnInstagram: "View on Instagram",
    openInbox: "Open in inbox",
    deletedNotice: "This comment was deleted on Instagram. Its text is kept here.",
  },
  commenter: {
    title: "Commenter",
    openProfile: "Open Instagram profile",
    fetchProfile: "Fetch profile",
    fetching: "Fetching profile…",
    refetch: "Refresh profile",
    fetchStarted: "Fetching the public profile",
    followers_one: "{{count}} follower",
    followers_other: "{{count}} followers",
    posts_one: "{{count}} post",
    posts_other: "{{count}} posts",
    fetchedAt: "Profile fetched {{when}}",
    source: {
      business_discovery: "Instagram public profile",
      user_profile: "Instagram profile API",
      none: "Not available",
    },
    noProfile: "No profile fetched yet. Instagram only shares public business and creator profiles, or people who messaged you.",
    counts: {
      comments: "Comments",
      negative: "Negative",
      toxic: "Toxic",
      spam: "Spam",
      flagged: "Flagged",
      hidden: "Hidden",
      deleted: "Deleted",
      archived: "Archived",
    },
    archiveAll: "Archive all their comments",
    hideAll: "Hide all their comments",
    archiveAllConfirm: "Archive all comments by @{{name}}?",
    hideAllConfirm: "Hide all comments by @{{name}} on Instagram?",
    archiveAllHint: "Archived comments leave the default views. You can unarchive them later.",
    hideAllHint: "Hidden comments stay visible to the author only. This runs as a job.",
    openContact: "Open profile",
    verified: "Verified",
    followsYou: "Follows you",
  },
  people: {
    title: "People",
    description: "Everyone who commented on an account, with moderation counts.",
    account: "Account",
    search: "Search people…",
    sortLabel: "Sort",
    sort: {
      recent: "Most recent",
      comments: "Most comments",
      negative: "Most negative",
      toxic: "Most toxic or spam",
    },
    markFilter: "Mark",
    markOpts: {
      all: "Everyone",
      any: "Marked",
      harmful: "Harmful",
      troll: "Known trolls",
      vip: "VIP",
      none: "Unmarked",
    },
    empty: "No commenters yet",
    emptyHint: "People appear here once they comment on this account.",
    emptyFiltered: "Nobody matches",
    last: "Last comment {{when}}",
    actions: "Actions for @{{name}}",
    count_one: "{{count}} person",
    count_other: "{{count}} people",
  },
  contactData: {
    title: "Personal data",
    hint: "Export everything Malfak stores about this person, or erase it. Admins and owners only; both are audited.",
    export: "Export data (JSON)",
    exported: "Export downloaded",
    delete: "Delete data",
    deleteTitle: "Erase all data about {{name}}?",
    deleteHint: "Deletes the person, their comments, conversations, messages and tags from Malfak. It doesn't delete anything on Instagram. This can't be undone.",
    typeToConfirm: "Type {{name}} to confirm",
    deleted: "Contact data erased",
    adminOnly: "Only admins and owners can export or erase personal data.",
    flags: "Tags",
    profile: "Public profile",
  },
  tags: {
    title: "Tags and AI categories",
    hint: "Built-in tags and your own tags work on comments, conversations and people. Rules can add them too.",
    builtIn: "Built-in tags",
    custom: "Custom tags",
    count_one: "{{count}} item",
    count_other: "{{count}} items",
    newTag: "New tag",
    label: "Name",
    labelPlaceholder: "e.g. Wholesale",
    color: "Colour",
    create: "Create tag",
    created: "Tag created",
    save: "Save",
    saved: "Tag saved",
    rename: "Edit {{label}}",
    delete: "Delete {{label}}",
    deleteTitle: "Delete the tag “{{label}}”?",
    deleteHint: "It's removed from every comment, conversation and person.",
    deleted: "Tag deleted",
    adminOnlyDelete: "Only admins can delete tags",
    empty: "No custom tags yet",
    emptyHint: "Create tags like “Wholesale” or “Influencer” to organize your inbox.",
    key: "Key: {{key}}",
    // ALP-83: custom AI categories (tags the classifier assigns)
    sections: "Kinds of labels",
    tabTags: "Tags",
    tabCategories: "AI categories",
    categoriesHint: "Your own AI categories (e.g. positive, negative, wants a refund). The AI sorts new comments into them with a confidence; rules can use “AI category is …”.",
    newCategory: "New AI category",
    createCategory: "Create category",
    categoryEmpty: "No AI categories yet",
    categoryEmptyHint: "Describe a label in plain words and give a few examples; the AI does the rest.",
    description: "Description",
    descriptionPlaceholder: "e.g. the customer is happy with the product",
    examples: "Examples",
    examplesPlaceholder: "Type an example and press Enter",
    scope: "Applies to",
    allAccounts: "All accounts",
    minConfidence: "Tag at confidence",
    categoryBadge: "AI category",
    noDescription: "No description",
  },
};
